<template>
	<el-dialog title="评价逻辑配置" center :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="700px">
		<p class="top-p">
			<span>{{ skillName }}：</span>
			{{ levelName }}
		</p>
		<el-form ref="form" :model="form" label-width="100px" size="small">
			<el-form-item label="所需课程包" prop="bundleIdList">
				<el-checkbox-group v-model="form.bundleIdList">
					<el-checkbox v-for="item in courseList" :key="item.id" :label="item.id">{{ item.bundleName }}</el-checkbox>
				</el-checkbox-group>
			</el-form-item>
			<el-form-item label="所需MIF值">
				<div class="grid-box">
					<div v-for="value in mifList">
						{{ value.name }}
						<el-input v-model="value.val" maxlength="3" placeholder="请输入内容"></el-input>
					</div>
				</div>
			</el-form-item>
			<el-form-item label="所需积分值" prop="points">
				<div class="item-1">
					最低
					<el-input v-model="form.points" maxlength="3"></el-input>
					分
				</div>
			</el-form-item>
			<el-form-item label="外部证书要求" prop="extCerts">
				<div class="item-1">
					最少
					<el-input v-model="form.extCerts" maxlength="3"></el-input>
					个
				</div>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { debounce } from "@/utils/debounce";
import { listByCodesPerm, courseSkillBundleList, courseSkillLevelUD, courseSkillDetailById } from "@/api/skill";
export default {
	data() {
		return {
			dialogVisible: false,
			submitLoading: false,
			mifList: [],
			courseList: [],
			levelName: "",
			skillName: "",
			form: {
				id: "",
				bundleIdList: [],
				points: "",
				extCerts: "",
			},
		};
	},
	methods: {
		// 初始化弹窗
		init(row) {
			this.dialogVisible = true;
			this.submitLoading = false;
			this.form.id = row.id;
			this.levelName = row.levelName;
			this.skillName = row.skillName;
			this.getInitList(row);
		},
		// 关闭弹窗
		handleClose() {
			this.dialogVisible = false;
			this.submitLoading = true;
		},
		// 获取初始化数据
		async getInitList(row) {
			console.log(row);
			const [mifRes, bundleRes, detailRes] = await Promise.all([
				listByCodesPerm({ codes: "mifType" }),
				courseSkillBundleList({ skillId: row.skillId }),
				courseSkillDetailById({ id: row.id }),
			]);
			this.courseList = bundleRes.data || [];
			const { bundleList = [], points, extCerts, mifList = [] } = detailRes.data || {};
			this.form.bundleIdList = bundleList.map((item) => item.bundleId);
			this.form.points = points ?? "";
			this.form.extCerts = extCerts ?? "";
			this.mifList = mifList.length
				? mifList.map((item) => ({ ...item, val: item.needVal, mifId: item.mifType, name: item.mifName }))
				: mifRes.data.mifType.map((item) => ({ ...item, val: "", mifId: item.id }));
		},
		// 提交表单
		handleSubmit: debounce(function () {
			if (this.submitLoading) return;
			this.$refs.form.validate((valid) => {
				if (!valid) return;

				this.form.mifIdValList = this.mifList.map((item) => ({
					mifId: item.mifId,
					mifVal: item.val,
				}));
				courseSkillLevelUD(this.form, true).then((res) => {
					this.submitLoading = false;
					if (res.code != "0") return this.$message.error(res.msg);
					this.$message.success("保存成功");
					this.handleClose();
				});
			});
		}, 300),
	},
};
</script>

<style lang="scss" scoped>
.top-p {
	margin-bottom: 20px;
	font-size: 18px;
	span {
		display: inline-block;
		// width: 100px;
		text-align: right;
	}
}
.grid-box {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 10px;
	.el-input {
		width: 100px;
	}
}

.el-form-item ::v-deep .el-form-item__label {
	font-weight: bold;
}

.item-1 {
	display: flex;
	.el-input {
		width: 60px;
		margin: 0 5px;
	}
}
</style>
